module.exports = __webpack_public_path__ + "img/p6.12b67134.png";